@if (label && !pairedWith) {
  <div class="label-column">
    <div>{{label}}</div>
  </div>
}
@if (!readonly || !useCustomReadonlyLayout) {
  <div class="input-section" (click)="handleButtonClick($event)">
    <div class="input-column primary" [attr.readonly]="readonly ? '' : null">
      <!-- Desktop: use input element for direct typing -->
      @if (!isMobile) {
        <input #input1 [value]="text1" (input)="handleText1Input($event)"
          [readonly]="readonly || notEditable" [disabled]="disabled"
          [placeholder]="primaryPlaceholder"
          [ngClass]="{ 'len-XS': valueLen === 'XS' || valueLen == null || valueLen === '', 'len-S': valueLen === 'S', 'len-M': valueLen === 'M', 'len-L': valueLen === 'L', 'len-XXS': valueLen === 'XXS' }"
          (keyup)="onTextsChange()" (blur)="onTextsBlur($event)" (focus)="onTextsClick($event)"
          (keydown)="onTextsKeyDown($event)" [attr.maxlength]="maximumChars" />
      }
      <!-- Mobile: use div element to prevent native keyboard -->
      @if (isMobile) {
        <div #display1 class="display-value"
          [class.has-value]="text1"
          [class.placeholder]="!text1"
          [attr.readonly]="readonly || notEditable ? '' : null"
          [attr.disabled]="disabled ? '' : null"
          [ngClass]="{ 'len-XS': valueLen === 'XS' || valueLen == null || valueLen === '', 'len-S': valueLen === 'S', 'len-M': valueLen === 'M', 'len-L': valueLen === 'L', 'len-XXS': valueLen === 'XXS' }"><span class="value-text" [class.selected]="isShowingSelection(display1)">{{
        text1 || primaryPlaceholder }}</span>@if (isShowingCursor(display1)) {
        <span
        class="cursor"></span>
      }</div>
    }
  </div>
  @if (unit2name != null) {
    <div class="input-column secondary">
      <!-- Desktop: use input element -->
      @if (!isMobile) {
        <input class="secondary" [value]="text2" (input)="handleText2Input($event)"
          [readonly]="readonly" [disabled]="disabled" placeholder="-- " (keyup)="onTextsChange()"
          (blur)="onTextsBlur($event)" (focus)="onTextsClick($event)" (keydown)="onTextsKeyDown($event)"
          [ngClass]="{ 'len-XS': value2Len === 'XS' || value2Len == null || value2Len === '', 'len-S': value2Len === 'S', 'len-M': value2Len === 'M', 'len-L': value2Len === 'L', 'len-XXS': value2Len === 'XXS' }" />
      }
      <!-- Mobile: use div element -->
      @if (isMobile) {
        <div #display2 class="display-value secondary"
          [class.has-value]="text2"
          [class.placeholder]="!text2"
          [attr.readonly]="readonly ? '' : null"
          [attr.disabled]="disabled ? '' : null"
          [ngClass]="{ 'len-XS': value2Len === 'XS' || value2Len == null || value2Len === '', 'len-S': value2Len === 'S', 'len-M': value2Len === 'M', 'len-L': value2Len === 'L', 'len-XXS': value2Len === 'XXS' }"><span class="value-text" [class.selected]="isShowingSelection(display2)">{{
        text2 || '-- ' }}</span>@if (isShowingCursor(display2)) {
        <span class="cursor"></span>
      }</div>
    }
  </div>
}
</div>
@if (showUnit && !unit2name && (unit1short || unit1name)) {
  <!-- Single unit display -->
  <div class="unit-column" [class.clickable]="!isMobile && multipleUnits && !lockUnit && !readonly && !disabled"
    [attr.tappable]="!readonly && !disabled ? '' : null"
    (click)="onUnitColumnClick($event)">
    <span class="unit-label">{{ unit1short || unit1name }}</span>
    @if (multipleUnits && !lockUnit && !readonly && !disabled) {
      <cs-icon name="arrow-dropdown"></cs-icon>
    }
  </div>
}
@if (showUnit && unit2name && (unit1short || unit1name)) {
  <!-- Dual unit display -->
  <div class="unit-column" [class.clickable]="!isMobile && multipleUnits && !lockUnit && !readonly && !disabled"
    [attr.tappable]="!readonly && !disabled ? '' : null"
    (click)="onUnitColumnClick($event)">
    <span class="unit-label">{{ unit1short || unit1name }} / {{ unit2name }}</span>
    @if (multipleUnits && !lockUnit && !readonly && !disabled) {
      <cs-icon name="arrow-dropdown"></cs-icon>
    }
  </div>
}
}
@if (readonly && useCustomReadonlyLayout) {
  <div [attr.have-ballpark]="makeBallpark ? '' : null"
    [attr.have-unit]="unit2name != null || unit1name ? unit1name || unit2name : null"
    [attr.customReadonly]="readonly && useCustomReadonlyLayout ? '' : null"
    [ngClass]="{ 'len-XS': valueLen === 'XS' || valueLen == null || valueLen === '', 'len-S': valueLen === 'S', 'len-M': valueLen === 'M', 'len-L': valueLen === 'L', 'len-XXS': valueLen === 'XXS' }">
    {{ fullText }}
  </div>
}